import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { PROFILE_STATISTICS_FEATURE_KEY } from './keys';
import { profileStatisticsReducer } from './reducers/profile-statistics.reducer';
import { ProfileStatisticsEffects } from './effects/profile-statistics.effects';

export const profileStatisticsStoreProviders = [
    provideState(PROFILE_STATISTICS_FEATURE_KEY, profileStatisticsReducer),
    provideEffects(ProfileStatisticsEffects),
];

export { ProfileStatisticsFacade } from './facades/profile-statistics.facade';
export { profileStatisticsCleanup } from './guards/cleanup.guard';
export { ProfileStatistics } from './models';
export type { ProfileStatisticsDto } from './models';
